import { OrganizationDTO } from './organization';
import { Media } from './media';
import { UserDTO } from '.';
import { Category } from './category';
import { Skill } from './skill';
import { TaskDraftCategory } from './TaskDraftCategory';
import { Task } from './task'; // Импортируем TaskDTO
import { ManagerDTO } from './manager';

export enum TaskDraftStatus {
    IN_PROCESS = "IN_PROCESS",
    REJECTED = "REJECTED",
    FOR_REVISION = "FOR_REVISION",
    READY = "READY",
    PAID = "PAID",
}

export interface TaskDraftDTO {
    id?: string;
    title: string;
    description: string;
    priceInKopecks?: number;
    deadline?: string;
    estimatedHours?: number;
    priority?: number;
    requirements?: string;
    neededUsers?: number;
    organizationId?: string;
    managerId?: string;
    createdAt?: string;
    updatedAt?: string;
    organization?: OrganizationDTO;
    manager?: ManagerDTO;
    media?: Media[];
    status?: TaskDraftStatus;
    skills?: Skill[];
    taskDraftCategories?: TaskDraftCategory[];
    tasks?: Task[];
}

// New interface for payload specifically for updating a TaskDraft
export interface TaskDraftUpdatePayload {
    id?: string;
    title: string;
    description: string;
    priceInKopecks?: number;
    deadline?: string;
    estimatedHours?: number;
    priority?: number;
    requirements?: string;
    neededUsers?: number;
    organizationId?: string;
    managerId?: string;
    status?: TaskDraftStatus;
    updatedAt?: string;
    taskDraftCategories?: Array<{ categoryId: string }>; // Only send IDs for categories
    // Explicitly exclude navigation properties like 'organization', 'manager', 'media', 'skills', 'tasks'
}
